"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var of_1 = require("rxjs/internal/observable/of");
var operators_1 = require("rxjs/operators");
/**
 * Wraps ajax calls with a status: pending, succeeded or failed.
 * This pipe function is based on switch map, so all previous requests
 * in pending state will be cancelled by emitting a new one.
 *
 * Returned data holds information about status, response and initial request.
 *
 * @param withAjax - transformation function from Request to Observable Response.
 */
function http(withAjax) {
    return operators_1.switchMap(function (req) {
        return withAjax(req).pipe(operators_1.map(function (res) { return ({
            status: 'succeeded',
            req: req,
            res: res
        }); }), operators_1.startWith({
            status: 'pending',
            req: req
        }), operators_1.catchError(function (res) {
            return of_1.of({
                status: 'failed',
                req: req,
                res: res,
                error: res.xhr.response
            });
        }), 
        // pending + succeeded/failed
        operators_1.take(2));
    });
}
exports.http = http;
//# sourceMappingURL=http.js.map